import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { DynamicFormCustomEvent } from '../dynamic-field-type/dynamic-field-type.component';

@Component({
    selector: 'lockton-apps-dynamic-form-cell',
    templateUrl: './dynamic-form-cell.component.html',
    styleUrls: ['./dynamic-form-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DynamicFormCellComponent {
  @Input() value: any;
  @Input() parentValue: any;
  @Input() type!: string;
  @Input() addonLeft!: string;
  @Input() addonRight!: string;
  @Input() decimalFormat!: string;
  @Input() options!: any;
  @Input() displayWith!: (value: any, row?: any) => string;

  @Output() customEvent = new EventEmitter<DynamicFormCustomEvent>();
}
